import React, { useMemo, useState } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { BlogContext, BlogList } from '../../components/blog/list';

export function BlogItemContainer(props) {
  const params = props.match.params;

  const [results, setResults] = useState();
  const blogContext = useMemo(() => {
    return {
      setResults
    };
  }, []);
  const result = results ? results[0] : undefined;

  return (
    <Container fluid>
      <Container>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/blog">
              <BreadcrumbItem>
                <Link to="/blog">Blog</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to={`/blog/${params.id}`}>
              <BreadcrumbItem>
                <Link to={`/blog/${params.id}`}>{result ? result.title : params.id}</Link>
              </BreadcrumbItem>
            </LinkContainer>
          </Breadcrumb>
        </Row>
      </Container>
      <Container>
        <BlogContext.Provider value={blogContext}>
          <BlogList slug={params.id} />
        </BlogContext.Provider>
      </Container>
    </Container>
  );
}

export default withRouter(BlogItemContainer);



// WEBPACK FOOTER //
// ./src/containers/Blog/BlogItem.js